var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-box acea-row row-between-wrapper" }, [
    _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.titleTxt))]),
    _c("div", { staticClass: "textVal" }, [
      _vm.defaultVal
        ? _c("span", [_vm._v(_vm._s(_vm.defaultVal))])
        : _c("span", { staticClass: "place" }, [_vm._v(_vm._s(_vm.tipVal))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }